import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { LoadingSpinner } from '../LoadingSpinner';

import './styles/InlineQuery.css';

const InlineQuery = ({ children, query, smaller, useChildForLoading }) => {
  let content = null;
  const empty = isEmpty(query.data);

  switch (true) {
    case query.loading && !useChildForLoading:
      content = <LoadingSpinner />;
      break;
    case isEmpty(query.data) && !query.loading:
      content = <p className="tvt-inline-query__no-results">No Results</p>;
      break;
    default:
      return children(query);
  }

  const className = classnames('tvt-inline-query', {
    'tvt-inline-query--loading': query.loading,
    'tvt-inline-query--empty': !query.loading && empty,
    'tvt-inline-query__smaller': smaller
  });

  return <div className={className}>{content}</div>;
};

InlineQuery.propTypes = {
  children: PropTypes.func.isRequired,
  query: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    loading: PropTypes.bool.isRequired
  }).isRequired,
  smaller: PropTypes.bool,
  useChildForLoading: PropTypes.bool
};

InlineQuery.defaultProps = {
  smaller: false,
  useChildForLoading: false
};

export default InlineQuery;
